import Config from '../../config';
import Model from '../../model/model';
import Module from '../../core/module';
import Schedule from '../../model/schedule';
import Task from '../../model/task';

import { hashify } from '../../utils/arrays';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { unixts } from '../../utils/date';
import { beginLock, endLock } from '../../loader';
import { roleAICKai } from '../../roles';
import { pickSingleTypeForTask, save } from '../../model/task.utils';





const
    POPUP_NEW = 'schedule-template--popup-new',
    POPUP_EDIT = 'schedule-template--popup-edit';

    



export default Module.extend( { 

    template: 'jst/module.schedule.templates.form',

    url() {
        return this.model.id
            ? `schedule/${this.schedule_.id}/template/${this.model.id}`
            : `schedule/${this.schedule_.id}/new-template`;
    },

    open({ schedule, scheduleId, templateTask, templateTaskId, ...otherArgs }) {
        if (!Config.privileges().includes( 'access_schedule' ))
            return Promise.reject( '403 Forbidden' );

        const schedulePromise = schedule
            ? Promise.resolve( schedule ) : Schedule.byId( scheduleId );
        const templateTaskPromise = templateTask
            ? Promise.resolve( templateTask ) : Task.byId( templateTaskId );

        return Promise.all( [schedulePromise, templateTaskPromise ] )
            .then( ([schedule, templateTask]) => 
                this.openSchedule( { schedule, templateTask, ...otherArgs } ) );
    },

    openSchedule({ schedule, templateTask }) {
        if (schedule.get( 'contract' ))
            // will not be sent to server
            templateTask.set( 'contract_id',
                schedule.get( 'contract').id );

        // edit
        if (templateTask.id)
            return this.schedule_ = schedule, this.bind( templateTask );

        // create
        templateTask.capabilities_ = {
            edit: true,
            update_title: true, update_text: true,
            update_type: true, update_priority: true, update_point: true,
            update_deadline: true,
            update_custom_fields: true,
            assign_department: 
                roleAICKai.includes( Config.role() ) ||
                'ORG_ADMINISTRATOR' === Config.roleCode(),
            assign_user: 
                roleAICKai.includes( Config.role() ) ||
                'ORG_ADMINISTRATOR' === Config.roleCode(),
        };
        
        templateTask.set( 'date', unixts( new Date() ) );

        if (schedule.get( 'cluster' ))
            templateTask.set( 'cluster_id', 
                schedule.get( 'cluster' ).id );

        else if (schedule.get( 'organization' )) {
            const defaultAssigneeId = this.options.organizations.toJSON()
                .filter( org => org.id == schedule.get( 'organization' ).id )
                [0]
                .default_assigned_organization_id;
            templateTask.set( {
                organization_id: schedule.get( 'organization' ).id,
                assigned_organization_id: defaultAssigneeId || undefined
            } );
        }

        const type = pickSingleTypeForTask( templateTask, this.options );
        if (type)
            templateTask.set( 'type_id', type.id );

        return this.schedule_ = schedule, this.bind( templateTask );
    },

    start() {
        this.listenTo( this.model, 'change', 
            () => this.Buttons.render() );

        // AS IN /module/tasks/form.js

        // but this form also works in CREATE-mode,
        // so do not block interface in this case
        if (!this.model.id)
            return this;

        const org = this.options.organizations.toJSON()
            .find( org => org.id == this.model.get( 'organization_id' ) );
        const type = this.options.types.toJSON()
            .find( type => type.id == this.model.get( 'type_id' ) );
        const isTypeAvailable = type
            ? type.role_ids == null || type.role_ids.includes( Config.role() ) || type.role_ids.includes( +Config.role() )
            : false;
        if (org && isTypeAvailable)
            this.TaskForm.focus();
        else
            // task of deleted org/cluster or unavailable type
            this.TaskForm.disable(),
            // this.Schedule && this.Schedule.disable(),
            this.Map && this.Map.disable(),
            // this.Comments.disable();
            this.Attachments.disable();

        // no checking for capabilities ("edit", "update_point")
        // because all caps are "true"-valued (see serialize() below)

        return this;
    },

    stop() {
        this.stopListening( this.model );
        return this;
    },

    serialize() {
        return {
            schedule: this.schedule_ instanceof Model ? this.schedule_.toJSON() : this.schedule_,
            capabilities: {
                edit: true,
                update_title: true, update_text: true,
                update_type: true, update_priority: true, update_point: true,
                update_deadline: true,
                update_custom_fields: true,
                assign_department: true,
                assign_user: true,
            },
            hasDiff: () => this.TaskForm.hasDiff( { fields: this.options.fields } ),
        };
    },

    events: {

        'click .-save'() {
            const 
                onResolve = (/*schedule*/) => 
                    this.trigger( Module.BACK ),

                onReject = message => {
                    endLock( this );
                    handle( this.TaskForm, error( message ) );
                };

            beginLock( this );

            const { result, messages } = this.TaskForm.validate();
            if (!result)
                return onReject( messages[0] /* [text, field] */ );
            
            return save( this, { contract_id: true } ).then( ({ task }) => 
                    new Schedule( { id: this.schedule_.id } ).patch( {
                        templates: {
                            add: [{ id: task.id }]
                        }
                    } ) )
                .then( onResolve, onReject );
        },

        'click .-close'() {
            this.trigger( Module.BACK );
        },

    },

    [Module.event( 'Map:map:click' )](location) {
        if (!this.Map.disabled())
            this.model.set( 'location', location ),
            this.Map.render();
    },

    [Module.event( 'Map:service-object:choose' )]({ objectId, layerId }) {
        if (!this.Map.disabled())
            if (this.model)
                this.model.set( {
                    service_object_id: objectId,
                    service_object_layer_id: layerId
                } );
    },

    [Module.event( 'Map:address:choose' )](attrs) {
        if (!this.Map.disabled())
            this.model.set( 'location', attrs.coords ),
            this.Map.render();
    },
        
}, {

    POPUP_NEW,

    POPUP_EDIT,

} );



// WEBPACK FOOTER //
// ./src/js/module/schedule/templates.form.js